import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import dayjs from 'dayjs'
import { Table, Spin, Space } from 'antd'
import type { TablePaginationConfig } from 'antd'
import { useQuery } from '@apollo/client'
import { LAST_SUBMITS, FreeAnswersDataType } from 'graphql/FreeAnswers'
import { ALL_ADDRESSES, AllAddressesDataType } from 'graphql/addresses'
import { ListWrapper } from '../styles'
import { Address } from 'types/address'
import { FreeAnswer } from 'types/freeAnswer'

const LastSubmits: React.FC = () => {
  const { t } = useTranslation()
  const [currentPage, setCurrentPage] = useState<number>(1)
  const [currentPageSize, setCurrentPageSize] = useState<number>(10)
  const [currentFilters, setCurrentFilters] = useState()

  const { loading, data } = useQuery<FreeAnswersDataType>(LAST_SUBMITS, {
    variables: {
      pagination: { page: currentPage, pageLength: currentPageSize },
      filters: currentFilters,
    },
  })
  const { loading: loadingAddresses, data: dataAddresses } =
    useQuery<AllAddressesDataType>(ALL_ADDRESSES)

  const onTableChange = (
    pagination: TablePaginationConfig,
    filters: Record<string, any>
  ) => {
    if (pagination.page) setCurrentPage(pagination.page)
    if (pagination.pageSize) setCurrentPageSize(pagination.pageSize)
    if (filters?.center)
      setCurrentFilters([{ field: 'address_ids', values: filters.center }])
  }

  if (loading || !data || loadingAddresses || !dataAddresses)
    return (
      <div className="absolute inset-1/2">
        <Spin size="large" />
      </div>
    )

  const { pagination, freeAnswers } = data.lastSubmits

  const dataSource = freeAnswers.map((freeAnswer: FreeAnswer) => ({
    key: freeAnswer.id,
    forwardedAt: dayjs(freeAnswer.forwardedAt).format('DD/MM/YYYY'),
    center: freeAnswer.addressName,
  }))

  const columns = [
    {
      title: t('common:forwarded-at'),
      dataIndex: 'forwardedAt',
      key: 'forwardedAt',
    },
    {
      title: t('common:center'),
      dataIndex: 'center',
      key: 'center',
      filters: dataAddresses.allAddresses.map((address: Address) => ({
        text: address.shortname,
        value: `${address.id}`,
      })),
    },
  ]

  return (
    <ListWrapper>
      <Space direction="vertical" size="middle" style={{ display: 'flex' }}>
        <Table
          dataSource={dataSource}
          columns={columns}
          pagination={{
            page: currentPage,
            pageSize: currentPageSize,
            total: pagination.totalItemsCount,
            showSizeChanger: true,
          }}
          onChange={onTableChange}
        />
      </Space>
    </ListWrapper>
  )
}

export default LastSubmits
